export var mutations = {
    setThreads: function (s, threads) { return s.threads = threads; },
    setSelectedThread: function (s, thread) { return s.selectedThread = thread; },
    setSelectedThreadLatestMessage: function (s, latestMessage) { return s.selectedThread.latestMessage = latestMessage; },
    setThreadListMetadata: function (s, meta) { return s.meta = meta; },
    setPagination: function (s, pagination) { return s.pagination = pagination; },
    setLoading: function (s, loading) { return s.loading = loading; },
};
